import React, { useMemo, useState } from "react";
import {
  Modal,
  Divider,
  Typography,
  Flex,
  // Dropdown,
} from "antd";
import { toast } from "react-toastify";
// import { EllipsisOutlined } from "@ant-design/icons";
import "./CustomerRangesDetailsModal.css";
import EditCustomerRangesModal from "./EditCustomerRangesModal";
import { getMlQcRulesRange } from "../../../../actions/qc";
import { toTitleCase } from "../../../../utils/helpers";
import RegularTestsGroupedView from "../RegularTestsGroupedView";

const { Text } = Typography;

// const menuItems = [
//   { key: "edit", label: "Edit" },
//   { key: "delete", label: "Delete" },
// ];

const CustomerRangesDetailsModal = ({
  open,
  onCancel,
  rangeData: range,
  // onDelete,
  // refetch,
}) => {
  const [rangeData, setRangeData] = useState(range);
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  /**
   * handles selecting option in dropdown menu
   * @param {*} menuOption selected option
   */
  // const onMenuItemClick = (menuOption) => {
  //   if (menuOption.key === "edit") {
  //     setShowEditModal(true);
  //   }
  //   if (menuOption.key === "delete") {
  //     onDelete();
  //   }
  // };

  /**
   * fetch updated range data
   */
  const getRangeData = async () => {
    const params = { customer_id: rangeData.customer_id };
    setLoading(true);
    const response = await getMlQcRulesRange(params);
    setLoading(false);
    if (response.success) {
      setRangeData(response.result?.length ? response.result[0] : range);
    } else {
      toast.error(response.message || "Something went wrong!");
    }
  };

  const checkTestCategories = useMemo(() => {
    const tests = rangeData.regular_tests || [];
    const testCagories = tests.reduce((acc, spec) => {
      if (spec.match_scope === "test_category") {
        acc.push(spec[spec.match_scope]);
      }
      return acc;
    }, []);
    return {
      isAllTestCategoies: testCagories.length === tests.length,
      csv: testCagories.length > 0 ? testCagories.join(", ") : "-",
    };
  }, [rangeData]);

  return (
    <>
      <Modal
        centered
        title="Customer Range Details"
        width={900}
        open={open}
        onCancel={onCancel}
        rootClassName="CustomerRangesDetailsModal"
        footer={null}
        loading={loading}
      >
        <div className="CustomerRangesDetailsModal__Content">
          <Flex vertical align="stretch" gap={16}>
            <Flex align="center" justify="space-between" gap={8}>
              <h4 className="CustomerRangesDetailsModal__Title">
                <strong>Customer ID: </strong>
                <span>{rangeData.customer_id || "Customer Range"}</span>
              </h4>
              {/* <div className="CustomerRangesDetailsModal__Status">
                <Dropdown
                  type="primary"
                  menu={{
                    items: menuItems,
                    onClick: onMenuItemClick,
                  }}
                  className="CustomerRangesDetailsModal__ActionDropdown"
                >
                  <EllipsisOutlined className="CustomerRangesDetailsModal__ActionIcon" />
                </Dropdown>
              </div> */}
            </Flex>

            <h4 className="CustomerRangesDetailsModal__Title">
              <strong>Scope: </strong>
              <span>{toTitleCase(rangeData.scope) || "-"}</span>
            </h4>

            <h4 className="CustomerRangesDetailsModal__Title">
              <strong>Sample Info: </strong>
              <span>{rangeData.sample_info || "-"}</span>
            </h4>

            <h4 className="CustomerRangesDetailsModal__Title">
              <strong>Regular Tests: </strong>
              {checkTestCategories.isAllTestCategoies && <span>{checkTestCategories.csv}</span>}
            </h4>
            {!checkTestCategories.isAllTestCategoies && <RegularTestsGroupedView regularTests={rangeData.regular_tests} />}
          </Flex>

          <Divider />

          <h4 className="CustomerRangesDetailsModal__Title">
            <strong>Range Specs: </strong>
          </h4>
          {rangeData.range_spec ? (
            <div className="CustomerRangesDetailsModal__RangeSpec">
              <Flex vertical gap={8}>
                <div className="CustomerRangesDetailsModal__RangeItem">
                  <Text strong>Type: </Text>
                  <Text>{rangeData.range_spec.type || "-"}</Text>
                </div>
                <div className="CustomerRangesDetailsModal__RangeItem">
                  <Text strong>Minimum Value: </Text>
                  <Text>{rangeData.range_spec.min_value || "-"}</Text>
                </div>
                <div className="CustomerRangesDetailsModal__RangeItem">
                  <Text strong>Maximum Value: </Text>
                  <Text>{rangeData.range_spec.max_value || "-"}</Text>
                </div>
                <div className="CustomerRangesDetailsModal__RangeItem">
                  <Text strong>Unit: </Text>
                  <Text>{rangeData.range_spec.unit || "-"}</Text>
                </div>
                <div className="CustomerRangesDetailsModal__RangeItem">
                  <Text strong>Raw Value: </Text>
                  <Text>{rangeData.range_spec.raw_value || "-"}</Text>
                </div>
              </Flex>
            </div>
          ) : (
            <div className="CustomerRangesDetailsModal__NoRangeSpec">
              <Text type="secondary">No range specifications defined</Text>
            </div>
          )}
        </div>
      </Modal>
      {showEditModal && (
        <EditCustomerRangesModal
          open={showEditModal}
          onCancel={() => setShowEditModal(false)}
          editData={rangeData}
          refetch={getRangeData}
        />
      )}
    </>
  );
};

export default CustomerRangesDetailsModal;
